import { userRole, claims } from '@/constants'
import { mapGetters } from 'vuex'


const mixin = {
  computed: {
    ...mapGetters('user', ['currentUser', 'currentUserAndProjectClaims']),

    currentUserRoleIsUser () {
      return this.currentUser?.role?.name === userRole.user
    },

    accessibleTabs () {
      return this.tabs.filter(tab => this.hasAccess('read', tab.route))
    }
  },

  methods: {
    hasAccess (actionName = 'write', claim = this.$route.meta.claim) {
      const claimName = claim.includes('Claim') ? claim : claims[claim]
      const currentClaim = this.currentUser?.role?.name === userRole.admin || (this.currentUserAndProjectClaims && this.currentUserAndProjectClaims[claimName])
      if (actionName === 'write') {
        return currentClaim === true
      }
      if (actionName === 'read') {
        return currentClaim === true || currentClaim === false
      }
    },

    redirectToChildRouteWithAccess () {
      this.$router.push({ name: this.$route.meta.redirectTo }).catch(() => {})
    }
  }
}


export default mixin
